import GetData from '../helpers/GetData'
import Params from '../helpers/Params';

export default class Cart {
    constructor() {
        this.storage_name = this.storage_name;
        this.params = new Params();

        this.updateCartButton();
    }

    request(callback) {
        new GetData({
            endpoint: 'build-cart',
            ajax_overrides: {
                method: 'POST',
                data: {
                    cart: this.getData(),
                    user_uuid: window.current_user?.uuid,
                    referrer: window.location.href,
                    exp_override: this.params.get('exp_override')
                }
            },
            callback: (data) => {
                //remove invalid items
                let returned_items = data.items.map(o => o.id);
                
                this.getData().forEach((local_item) => {
                    if(!returned_items.includes(local_item.item_id)) {
                        this.remove(local_item.item_id);
                    }
                });

                if(callback) {
                    this.latest_data = data;

                    callback(data);
                }
            }
        });
    }

    add(item_id, item_data) {
        let cart = this.getData();
        let cart_item = {};
        let item_result = {};

        if(!this.hasItem(item_id)) {
            let insert_index = cart.push({
                item_id: item_id,
                item_data: item_data,
                count: 1
            });

            item_result = cart[insert_index - 1];
        } else {
            cart.forEach((item, index) => {
                if(item.item_id == item_id) {
                    item.count += 1;

                    if(item_data) {
                        item.item_data = item_data;
                    }

                    item_result = item;
                }
            });
        }

        this.setData(cart);
        this.updateCartButton();

        return item_result;
    }

    hasItem(item_id) {
        let has_item = false;
        let cart = this.getData();

        cart.forEach((item) => {
            if(item.item_id == item_id) {
                has_item = true;
            }
        });

        return has_item;
    }

    remove(item_id, item_data, force = false) {
        let cart = this.getData();
        let item_result = {};

        if(this.hasItem(item_id)) {
            cart.forEach((item, index) => {
                if(item.item_id == item_id) {
                    item.count -= 1;

                    item_result = cart[index];

                    if(item.count == 0 || force == true) {
                        cart = cart.filter(data => data.item_id != item_id);
                    } else if(item_data) {
                        item.item_data = item_data;
                    }
                }
            });
        }

        this.setData(cart);
        this.updateCartButton();

        return item_result;
    }

    getData() {
        return JSON.parse(localStorage.getItem(this.storage_name)) ?? [];
    }

    getItem(item_id) {
        let cart = this.getData();
        let item_data = {};

        if(this.hasItem(item_id)) {
            cart.forEach((item) => {
                if(item.item_id == item_id) {
                    item_data = item;
                }
            });
        }

        return item_data;
    }

    updateItemData(item_id, item_data) {
        let cart = this.getData();

        if(this.hasItem(item_id) && item_data) {
            cart.forEach((item, index) => {
                if(item.item_id == item_id) {
                    item.item_data = item_data;
                }
            });
        }

        this.setData(cart);
    }

    getItemData(item_id) {
        let cart = this.getData();
        let item_data = {};

        if(this.hasItem(item_id)) {
            cart.forEach((item, index) => {
                if(item.item_id == item_id) {
                    item_data = item.item_data;
                }
            });
        }

        return item_data;
    }

    isEmpty() {
        let empty = false;
        let data = this.getData();

        if(data.length == 0) {
            empty = true;
        }

        return empty;
    }

    setData(cart_data) {
        localStorage.setItem(this.storage_name, JSON.stringify(cart_data));
    }

    clear() {
        localStorage.removeItem(this.storage_name);
        this.updateCartButton();
    }

    updateCartButton() {
        let meganav = document.querySelector('.js-meganav');

        if(this.isEmpty()) {
            meganav?.classList.remove('--cart-active');
        } else {
            meganav?.classList.add('--cart-active');
        }
    }
}
